module.exports = __webpack_public_path__ + "static/img/wang.7cb134b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wang.png
// module id = 91
// module chunks = 1